/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./RejectedTrafficContainer.less";
import moment from "moment";
import { Form } from "antd";
import { fetchRejectedTraffics } from "../../store/slices/rejected-traffic";
import { fetchTrafficStatus } from "../../store/slices/rtkDictionaries";
import RejectedTraffic from "../../components/RejectedTraffic/RejectedTraffic";
import { agreementsSearchActions } from "../../store/slices/agreementsSearch/agreementsSearch";

const RejectedTrafficContainer = () => {
  const [data, setData] = useState("");
  const [dataAccounts, setDataAccounts] = useState("");
  const [isLoadData, setIsLoadData] = useState(false);
  const { rejectedTraffics, rejectedTrafficsLoading } = useSelector((state) => state.rejected);
  const accounts = useSelector((state) => state.accounts);
  const dispatch = useDispatch();
  const nowDate = moment();
  const pastDate = moment().subtract(30, "days");
  const [form] = Form.useForm();
  const [fromDateValue, setFromDateValue] = useState(pastDate);
  const [toDateValue, setToDateValue] = useState(nowDate);

  const rejectedTrafficSearchParams = {
    accountIds: undefined,
    subscribers: undefined,
    subscribersThroughSubscriberIds: null,
    includeServiceUsageStatusIds: [],
    fromDate: "",
    toDate: "",
    rangeDate: [pastDate, nowDate],
    "subscriber.externalId": undefined,
    "organization.property.stringValue": undefined,
  };

  // Очистка списка accountSelect при входе и выходе
  useEffect(() => {
    dispatch(agreementsSearchActions.cleanAccounts());
    return () => dispatch(agreementsSearchActions.cleanAccounts());
  }, []);

  useEffect(() => {
    dispatch(fetchTrafficStatus());
    return () => {
      setData("");
      setIsLoadData(false);
    };
  }, []);

  useEffect(() => {
    setData(rejectedTraffics);
  }, [rejectedTraffics]);

  useEffect(() => {
    setDataAccounts(accounts);
  }, [accounts]);

  const getDate = (date) => {
    setFromDateValue(date[0]);
    setToDateValue(date[1]);
  };

  const handleSearchRejectsTraffic = (values) => {
    setIsLoadData(true);
    dispatch(fetchRejectedTraffics(values));
  };

  const resetSearchRejectsTraffic = () => {
    form.setFieldsValue(rejectedTrafficSearchParams);
    setIsLoadData(false);
    dispatch(agreementsSearchActions.cleanAccounts());
  };

  return (
    <RejectedTraffic
      form={form}
      isLoadData={isLoadData}
      dataAccounts={dataAccounts}
      data={data}
      rejectedTrafficsLoading={rejectedTrafficsLoading}
      fromDateValue={fromDateValue}
      toDateValue={toDateValue}
      handleSearchRejectsTraffic={handleSearchRejectsTraffic}
      resetSearchRejectsTraffic={resetSearchRejectsTraffic}
      rejectedTrafficSearchParams={rejectedTrafficSearchParams}
      getDate={getDate}
    />
  );
};

export default RejectedTrafficContainer;
